
/* custom select */

function initializeCustomSelect() {
    const selectWrapper = document.querySelector(".custom-select");
    const selectPlaceholder = document.querySelector(".select-placeholder");
    const optionsContainer = document.querySelector(".options");
    const options = document.querySelectorAll(".option");
    const selectElement = document.querySelector("#ContactFormSubject");

    if (!selectWrapper || !selectPlaceholder || !optionsContainer || !selectElement) {
        console.warn("Custom select elements not found, retrying...");
        return;
    }

    console.log("Custom select initialized.");

    selectPlaceholder.setAttribute("role", "combobox");
    selectPlaceholder.setAttribute("aria-haspopup", "listbox");
    selectPlaceholder.setAttribute("aria-expanded", "false");
    selectPlaceholder.setAttribute("tabindex", "0");
    optionsContainer.setAttribute("role", "listbox");

    options.forEach((option, index) => {
        option.setAttribute("role", "option");
        option.setAttribute("tabindex", "-1");
        option.setAttribute("id", `option-${index}`);
    });

    function toggleDropdown(open) {
        selectWrapper.classList.toggle("select-open", open);
        selectPlaceholder.setAttribute("aria-expanded", open.toString());
    }

    selectPlaceholder.addEventListener("click", function () {
        toggleDropdown(!selectWrapper.classList.contains("select-open"));
    });

    function selectOption(option) {
        selectPlaceholder.textContent = option.textContent;
        selectElement.value = option.getAttribute("data-value");
        selectPlaceholder.classList.add("selected");
        toggleDropdown(false);
        selectPlaceholder.setAttribute("aria-activedescendant", option.id);
    }

    options.forEach(option => {
        option.addEventListener("click", function () {
            selectOption(option);
        });
    });

    selectPlaceholder.addEventListener("keydown", function (event) {
        let currentIndex = [...options].findIndex(opt => opt.getAttribute("data-value") === selectElement.value);

        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleDropdown(!selectWrapper.classList.contains("select-open"));
        } else if (event.key === "ArrowDown") {
            event.preventDefault();
            let nextIndex = (currentIndex + 1) % options.length;
            selectOption(options[nextIndex]);
        } else if (event.key === "ArrowUp") {
            event.preventDefault();
            let prevIndex = (currentIndex - 1 + options.length) % options.length;
            selectOption(options[prevIndex]);
        } else if (event.key === "Escape") {
            toggleDropdown(false);
        }
    });

    document.addEventListener("click", function (e) {
        if (!selectWrapper.contains(e.target)) {
            toggleDropdown(false);
        }
    });
}

document.addEventListener("DOMContentLoaded", initializeCustomSelect);
document.addEventListener("shopify:section:load", initializeCustomSelect);
document.addEventListener("shopify:section:reorder", initializeCustomSelect);